import { ClipScene } from './ClipScene'
import { KeywordsScene } from './KeywordsScene'
import { QrScene } from './QrScene'
import { ReactionsScene } from './ReactionsScene'
import { SpeakingScene } from './SpeakingScene'
import { TitleScene } from './TitleScene'

export const SCENES = {
  clip: ClipScene,
  keywords: KeywordsScene,
  qr: QrScene,
  reactions: ReactionsScene,
  speaking: SpeakingScene,
  title: TitleScene,
} as const

export type SceneKind = keyof typeof SCENES
